export type AppUserRole = 'user' | 'creator' | 'admin' | 'superadmin';

export function isStaffRole(role: AppUserRole | null | undefined): boolean {
  return role === 'admin' || role === 'superadmin';
}

export function isSuperadminRole(role: AppUserRole | null | undefined): boolean {
  return role === 'superadmin';
}

/** Creator role OR any staff role (admins/superadmins also see Studio). */
export function isCreatorRole(role: AppUserRole | null | undefined): boolean {
  return role === 'creator' || role === 'admin' || role === 'superadmin';
}
